/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  account_inboxes_list() {
    return axios.get(`${this.url}/inboxes_list`);
  }

  limited_inboxes_list(agentId) {
    return axios.get(`${this.url}/limited_inboxes?agent_id=${agentId}`);
  }

  transfer_inboxes_list(params) {
    return axios.post(`${this.url}/transfer_inboxes`, params);
  }

  fetch_transfer_inboxes(id) {
    return axios.get(`${this.url}/transfer_inbox_list?id=${id}`);
  }
}

export default new Inboxes();
